import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Row, Col, Card, CardHeader, CardTitle, CardBody, CardFooter, FormGroup, Label, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import moment from 'moment';

import Toggle from '../../../../components/Form/Toggle';

import config from '../../../../config';
import { dateFormat } from '../../../../util/date';

import { getLoggedUser, acceptCGURequest } from '../../../User/UserActions';
import { getInstitutionsForLoggedUser } from '../../../Institution/InstitutionActions';
import { getConfig } from '../../../Config/ConfigActions';
import { displayErrors } from '../../../Error/ErrorActions';

import PageContent from '../../../Cms/components/content/PageContent';
import HtmlComponent from '../../../../components/Text/HtmlComponent';

class AppCGUAccept extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checkConditions: false,
            isSaving: false,
        };
    }

    handleChange = event => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [name]: value,
        });
    };

    handleValid = () => {
        if(this.state.checkConditions) {
            this.setState({
                isSaving: true,
            });
            this.props.dispatch(acceptCGURequest()).then(user => {
                this.setState({
                    isSaving: false,
                });
                if(user) {
                    displayErrors('success', this.props.intl.formatMessage({
                        id: 'appConditionsCheckSuccess',
                        defaultMessage: 'Done!',
                    }));
                } else {
                    displayErrors('error', this.props.intl.formatMessage({
                        id: 'alertGenericError',
                        defaultMessage: 'An error occured! Please try later...',
                    }));
                }
            });
        } else {
            displayErrors('warning', this.props.intl.formatMessage({
                id: 'appConditionsCheckError',
                defaultMessage: 'Please check the legal conditions!',
            }));
        }
    };

    render() {
        return (
            <Row>
                <Col xs="12" lg={{ size: 8, offset: 2 }} xl={{ size: 8, offset: 2 }}>
                    <h1 className="my-5 text-center">
                        <FontAwesomeIcon icon="handshake" /> <FormattedMessage id="appConditionsAcceptTitle" defaultMessage="Legal conditions" />
                    </h1>
                    <div className="mb-2">
                        <PageContent pageId="cgu" />
                        {(this.props.institutions || []).filter(institution => institution.legalConditions).map((institution, index) => (
                            <Card key={index} className="my-5">
                                <CardBody>
                                    <h2 className="my-3 text-center text-primary">{institution.name.toUpperCase()}</h2>
                                    <HtmlComponent text={institution.legalConditions} />
                                </CardBody>
                            </Card>
                        ))}
                    </div>

                    <Card className="mb-5">
                        <CardBody>
                            <FormGroup className="text-center">
                                <Toggle
                                    id="checkConditionsField"
                                    name="checkConditions"
                                    checked={this.state.checkConditions}
                                    onChange={this.handleChange}
                                />
                                <Label for="checkConditionsField" className="ps-2 align-text-bottom"><FormattedMessage id="appConditionsCheckLabel" defaultMessage="I have read and unreservedly accept the general conditions of use" /></Label>
                            </FormGroup>

                            {this.props.lastCGUTimestampUpdate && (
                                <div className="mt-3 text-end">
                                    <small><FormattedMessage id="appConditionsUpdateDate" defaultMessage="Updated the {date}" values={{ date: dateFormat(moment.unix(this.props.lastCGUTimestampUpdate), 'LL') }} /></small>
                                </div>
                            )}
                        </CardBody>
                        <CardFooter>
                            <Button color="success" outline block disabled={this.state.isSaving} onClick={this.handleValid}><FormattedMessage id="appAccessButton" defaultMessage="Access to {app}" values={{ app: config.application.name }} /> {this.state.isSaving ? <FontAwesomeIcon icon="spinner" spin /> : <FontAwesomeIcon icon="chevron-right" />}</Button>
                        </CardFooter>
                    </Card>
                </Col>
            </Row>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
        institutions: getInstitutionsForLoggedUser(store),
        lastCGUTimestampUpdate: getConfig(store, 'app-cgu-update'),
    };
}

AppCGUAccept.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    user: PropTypes.object,
    institutions: PropTypes.arrayOf(PropTypes.object),
    lastCGUTimestampUpdate: PropTypes.number,
};

export default connect(mapStateToProps)(withIntl(AppCGUAccept));
